// extracted by mini-css-extract-plugin
module.exports = {"switch":"fromSwitch_switch_3gUV9"};